import {
  RATING_SENTIMENT_HIGHLY_SATISFIED,
  RATING_SENTIMENT_VERY_SATISFIED,
  RATING_SENTIMENT_SATISFIED,
  RATING_SENTIMENT_DISSATISFIED,
  RATING_SENTIMENT_VERY_DISSATISFIED,
  type RatingSentiment,
} from '@travel-frontend/ui-components';

import {
  REVIEW_SCORE_AMADEUS_MAX,
  REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT,
  REVIEW_SCORE_AMADEUS_THRESHOLD_VERY_GOOD,
  REVIEW_SCORE_AMADEUS_THRESHOLD_GOOD,
  REVIEW_SCORE_AMADEUS_THRESHOLD_FAIR,
} from '@/consts';
import {
  RatingCategories,
  type RatingCategory,
} from '@/modules/common/context/QueryParams/models';

const config: {
  scoreMax: number;
  thresholds: Record<RatingCategory, number>;
} = {
  scoreMax: REVIEW_SCORE_AMADEUS_MAX,
  thresholds: {
    [RatingCategories.poor]: 0,
    [RatingCategories.fair]: REVIEW_SCORE_AMADEUS_THRESHOLD_FAIR,
    [RatingCategories.good]: REVIEW_SCORE_AMADEUS_THRESHOLD_GOOD,
    [RatingCategories.very_good]: REVIEW_SCORE_AMADEUS_THRESHOLD_VERY_GOOD,
    [RatingCategories.excellent]: REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT,
  },
};

export const getRatingCategoryThreshold = (
  ratingCategory: RatingCategory
): number => {
  return config.thresholds[ratingCategory];
};

export const getRatingCategoryMaximum = (): string => {
  return config.scoreMax.toFixed(1);
};

export const mapAmadeusRatingToSentiment = (
  amadeusRating: number
): RatingSentiment => {
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT) {
    return RATING_SENTIMENT_HIGHLY_SATISFIED;
  }
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_VERY_GOOD) {
    return RATING_SENTIMENT_VERY_SATISFIED;
  }
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_GOOD) {
    return RATING_SENTIMENT_SATISFIED;
  }
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_FAIR) {
    return RATING_SENTIMENT_DISSATISFIED;
  }
  return RATING_SENTIMENT_VERY_DISSATISFIED;
};

export const mapAmadeusRatingToRatingCategory = (
  amadeusRating: number
): RatingCategory => {
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT) {
    return RatingCategories.excellent;
  }
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_VERY_GOOD) {
    return RatingCategories.very_good;
  }
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_GOOD) {
    return RatingCategories.good;
  }
  if (amadeusRating >= REVIEW_SCORE_AMADEUS_THRESHOLD_FAIR) {
    return RatingCategories.fair;
  }
  return RatingCategories.poor;
};
